
var utils = function(){
}

utils.setResizeFunc = function(callback){
  var resizeTimer;

  window.onresize = function(){
    if(typeof resizeTimer !== 'undefined')
      clearTimeout(resizeTimer);

    resizeTimer = setTimeout(callback, 100);
  }
}

export default utils;



/** WEBPACK FOOTER **
 ** ./utils.js
 **/